import React from 'react'
import { motion } from 'framer-motion'


const AboutUsHeader = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className='max-w-7xl mx-auto py-20 px-6 bg-gray-100 text-center rounded-xl shadow-md'
    >
      <h2 className="text-4xl font-bold text-[#29313f] mb-6 tracking-wide">
        Crafting Tomorrow, One Bold Build at a Time
      </h2>

      <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
      At <span className="font-semibold text-[#29313f]">Arqelio</span>, we’re driven by a passion for excellence and a vision for sustainability. From modern homes to major infrastructure, our expert team delivers innovative solutions that combine durability, efficiency, and design brilliance — all built to stand the test of time.
      </p>
    </motion.section>
  )
}

export default AboutUsHeader